
(function () {
  var placeholder = null;

  function isMobile() {
    return window.matchMedia('(max-width: 989px)').matches;
  }

  function getHeader() {
    return document.querySelector('[id^="smsm-header-"]');
  }

  function getDirection(header) {
    return (header && header.getAttribute('dir')) || document.documentElement.getAttribute('dir') || 'rtl';
  }

  function getElements() {
    var header = getHeader();
    if (!header) return null;

    var drawer = document.querySelector('.smsm-mobile-fixed-drawer') || header.querySelector('[data-smsm-drawer]');
    var overlay = document.querySelector('.smsm-mobile-fixed-overlay') || header.querySelector('[data-smsm-overlay]');
    var openBtn = header.querySelector('[data-smsm-open]');

    if (!drawer || !overlay || !openBtn) return null;

    return {
      header: header,
      drawer: drawer,
      overlay: overlay,
      openBtn: openBtn
    };
  }

  function prepareMobileMenu() {
    var els = getElements();
    if (!els || !isMobile()) return null;

    var dir = getDirection(els.header);

    if (!placeholder) {
      placeholder = document.createComment('smsm mobile drawer position');
    }

    if (!els.drawer.parentNode || els.drawer.parentNode !== document.body) {
      els.drawer.parentNode.insertBefore(placeholder, els.drawer);
      document.body.appendChild(els.drawer);
    }

    if (els.overlay.parentNode !== document.body) {
      document.body.appendChild(els.overlay);
    }

    els.drawer.classList.add('smsm-mobile-fixed-drawer');
    els.overlay.classList.add('smsm-mobile-fixed-overlay');

    els.drawer.classList.toggle('smsm-mobile-rtl', dir === 'rtl');
    els.drawer.classList.toggle('smsm-mobile-ltr', dir !== 'rtl');

    return els;
  }

  function restoreDesktopMenu() {
    var els = getElements();
    if (!els) return;

    closeMenu();

    if (placeholder && placeholder.parentNode && els.drawer.parentNode === document.body) {
      placeholder.parentNode.insertBefore(els.drawer, placeholder);
      placeholder.parentNode.removeChild(placeholder);
      placeholder = null;
    }

    if (els.overlay.parentNode === document.body && els.header) {
      els.header.appendChild(els.overlay);
    }

    els.drawer.classList.remove('smsm-mobile-fixed-drawer', 'smsm-mobile-rtl', 'smsm-mobile-ltr');
    els.overlay.classList.remove('smsm-mobile-fixed-overlay');
  }

  function openMenu() {
    var els = prepareMobileMenu();
    if (!els) return;

    els.drawer.classList.add('is-open');
    els.overlay.classList.add('is-open');
    els.drawer.setAttribute('aria-hidden', 'false');

    document.documentElement.classList.add('smsm-mobile-lock');
    document.body.classList.add('smsm-mobile-lock');
  }

  function closeMenu() {
    var drawer = document.querySelector('.smsm-mobile-fixed-drawer');
    var overlay = document.querySelector('.smsm-mobile-fixed-overlay');

    if (drawer) {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
    }

    if (overlay) {
      overlay.classList.remove('is-open');
    }

    document.documentElement.classList.remove('smsm-mobile-lock');
    document.body.classList.remove('smsm-mobile-lock');
  }

  document.addEventListener('click', function (event) {
    var openBtn = event.target.closest('[data-smsm-open]');

    if (!isMobile()) return;

    var els = prepareMobileMenu();
    if (!els) return;

    var insideDrawer = event.target.closest('.smsm-mobile-fixed-drawer');
    var isOverlay = event.target.classList.contains('smsm-mobile-fixed-overlay');

    if (openBtn) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      if (els.drawer.classList.contains('is-open')) {
        closeMenu();
      } else {
        openMenu();
      }

      return;
    }

    if (isOverlay) {
      event.preventDefault();
      closeMenu();
      return;
    }

    if (els.drawer.classList.contains('is-open') && !insideDrawer) {
      closeMenu();
    }
  }, true);

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('.smsm-mobile-fixed-drawer .smsm-sub-toggle');

    if (!toggle || !isMobile()) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    var li = toggle.closest('li');
    if (!li) return;

    li.classList.toggle('is-open');

    var plus = toggle.querySelector('.smsm-toggle-plus');
    if (plus) {
      plus.textContent = li.classList.contains('is-open') ? '−' : '+';
    }
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeMenu();
    }
  });

  window.addEventListener('resize', function () {
    if (isMobile()) {
      prepareMobileMenu();
    } else {
      restoreDesktopMenu();
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    if (isMobile()) {
      prepareMobileMenu();
    } else {
      restoreDesktopMenu();
    }
  });

  if (isMobile()) {
    prepareMobileMenu();
  }
})();
